import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  {
    testid: "service-card-tegole",
    span: "md:col-span-7",
    title: "Coperture in Tegole Tradizionali e Portoghesi",
    desc: "Posa a regola d'arte di tegole in terracotta, coppi e tegole portoghesi. Massima resistenza agli agenti atmosferici e resa estetica d'eccellenza per edifici storici e moderni.",
    img: "https://images.unsplash.com/photo-1610056868457-e61d6f9eeb86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHx0ZXJyYWNvdHRhJTIwcm9vZiUyMHRpbGVzJTIwYXJjaGl0ZWN0dXJlJTIwZGV0YWlsfGVufDB8fHx8MTc5Mjc5MDA2OHww&ixlib=rb-4.1.0&q=85",
    tag: "Tegole & Coppi",
  },
  {
    testid: "service-card-guaina",
    span: "md:col-span-5",
    title: "Impermeabilizzazione in Guaina Bituminosa",
    desc: "Membrane elastomeriche e plastomeriche armate di ultima generazione. Protezione totale da infiltrazioni per tetti piani, terrazzi e grondaie.",
    img: "https://images.unsplash.com/photo-1601277142977-2bd75b6b33be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxkYXJrJTIwYXJjaGl0ZWN0dXJlJTIwcm9vZiUyMHRpbGVzJTIwcm9vZmVycyUyMGNyYWZ0c21hbnNoaXAlMjBjb3BwZXIlMjByb29mfGVufDB8fHxibGFja3wxNzkyNzkwMDYyfDA&ixlib=rb-4.1.0&q=85",
    tag: "Guaina",
  },
  {
    testid: "service-card-finto-coppo",
    span: "md:col-span-5",
    title: "Pannelli Finto Coppo Coibentati",
    desc: "Pannelli sandwich isolanti con finitura effetto coppo. Isolamento termico e acustico avanzato con l'aspetto classico del tetto italiano.",
    img: "https://images.unsplash.com/photo-1579688212554-9efca19e9ed8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxkYXJrJTIwYXJjaGl0ZWN0dXJlJTIwcm9vZiUyMHRpbGVzJTIwcm9vZmVycyUyMGNyYWZ0c21hbnNoaXAlMjBjb3BwZXIlMjByb29mfGVufDB8fHxibGFja3wxNzkyNzkwMDYyfDA&ixlib=rb-4.1.0&q=85",
    tag: "Coibentati",
  },
  {
    testid: "service-card-lattoneria",
    span: "md:col-span-7",
    title: "Bonifica, Lattoneria e Grondaie in Rame",
    desc: "Sostituzione grondaie e pluviali in rame o alluminio preverniciato, smaltimento del vecchio manto e isolamento sottotetto certificato.",
    img: "https://images.unsplash.com/photo-1646324554833-f0b6a479fa5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxOTJ8MHwxfHNlYXJjaHw0fHxyb29mZXIlMjB3b3JraW5nJTIwcm9vZiUyMGNvbnN0cnVjdGlvbiUyMGNyYWZ0c21hbnxlbnwwfHx8fDE3OTI3OTAwNjh8MA&ixlib=rb-4.1.0&q=85",
    tag: "Lattoneria",
  },
];

export default function Services() {
  return (
    <section id="servizi" className="py-24 sm:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-14 max-w-3xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D97736] mb-4">I nostri interventi</p>
          <h2 className="font-syne font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            Ogni tetto, un'opera di precisione.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.testid}
              data-testid={s.testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative col-span-12 ${s.span} rounded-3xl overflow-hidden bg-[#14171E] border border-white/10 hover:border-[#D97736]/40 transition-colors duration-500`}
            >
              <div className="relative h-56 sm:h-64 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#14171E] via-[#14171E]/20 to-transparent" />
                <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.25em] text-[#F3F4F6] bg-[#0B0C0E]/70 backdrop-blur-md border border-white/10 rounded-full px-3 py-1.5">
                  {s.tag}
                </span>
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="font-syne font-semibold text-xl sm:text-2xl tracking-normal mb-3">{s.title}</h3>
                <p className="text-sm sm:text-base text-[#9CA3AF] leading-relaxed mb-6">{s.desc}</p>
                <button
                  onClick={() => scrollToId("#preventivo")}
                  className="flex items-center gap-2 font-outfit text-sm font-medium text-[#D97736] hover:text-[#E88D52] transition-colors duration-300"
                >
                  Richiedi preventivo
                  <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
